import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './styles/global.css';   // @imports tokens.css

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
